import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem } from '@mui/material';

import { queryApi } from 'src/api/queryApi';
import useUsers from 'src/hooks/useUsers';
import UserOption from 'src/pages/QueryPages/components/UserOption';
import { PR_TEAM_IDS } from 'src/constants/prTeam';

const UserSelect = ({ selectedUserId, query, mutate }) => {
  const { users } = useUsers();

  const filteredUsers = React.useMemo(() => {
    if (!users) return [];

    return users.filter((user) => PR_TEAM_IDS.includes(user.id) || user.id === selectedUserId);
  }, [users, selectedUserId]);

  const handleUserChange = async (event) => {
    const newUserId = event.target.value;

    const response = await queryApi.updateQuery(query.id, query.status, newUserId);

    if (response.status === 'Query Updated') {
      mutate((queries) => {
        return queries.map((q) => (q.id === query.id ? { ...q, userClaimID: newUserId } : q));
      }, false);
    }
  };

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <FormControl fullWidth onClick={handleClick} size="small">
      <Select value={selectedUserId} onChange={handleUserChange}>
        {filteredUsers.map((user) => (
          <MenuItem key={user?.id} value={user?.id}>
            <UserOption user={user} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

UserSelect.propTypes = {
  users: PropTypes.array.isRequired,
  selectedUserId: PropTypes.number.isRequired,
  query: PropTypes.object.isRequired,
  mutate: PropTypes.func.isRequired,
};

export default UserSelect;
